{
    "Profile_Dwellings_Animal.animal": "Animal",
    "Profile_Dwellings_Animal.animalDetails": "Animal Details",
    "Profile_Dwellings_Animal.number": "Number",
    "Profile_Dwellings_Animal.type": "Type",
    "Profile_Dwellings_Animal.breed": "Breed",
    "Profile_Dwellings_Animal.biteHistory": "Bite History"
}
